export default __webpack_public_path__ + "static/media/img-0103-canada-full-face.dff24436.png";